import ProfilePage from './Components/ProfilePage';



const Admin = () => {

    return (

        <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
            <ProfilePage />
        </div >

    );
};

export default Admin;
